// src/lib/supabase.ts
export const SUPABASE_URL = "https://northwind-ops-demo.supabase.co";
export const SUPABASE_ANON_KEY = "public-anon-key";
